/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import {
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
  Checkbox,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import FormInput from "../../../components/forms/form-Input";
import {
  ACTIVITY_TYPES,
  contractsDefault,
  contractSLADefault,
  contractStatus,
  invoicingCatalogDefault,
  SERVICE_TYPES,
} from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import FormHookDatePicker from "../../../components/forms/form-hook-date-picker";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import { dateFormat } from "../../../utils/constants";
import { useLookupRegions } from "../../../services/lookups-mutations";

export default function Contracts({
  onPrevStep,
  onNextStep,
  contracts,
  currencies,
  addData,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [currentEditingSLA, setCurrentEditingSLA] = useState(null);
  const [currentEditingCatalog, setCurrentEditingCatalog] = useState(null);
  const [regionList, setRegionList] = useState([]);
  const {
    mutate: getRoutes,
    data: regions,
    reset: resetRegions,
  } = useLookupRegions();
  useEffect(() => {
    getRoutes("UAE");
  }, []);
  useEffect(() => {
    if (regions) {
      setRegionList(
        regions.data.map((elm) => ({ id: elm.name, text: elm.name }))
      );
      resetRegions();
    }
  }, [regions]);

  const {
    handleSubmit,
    control,
    getValues,
    watch,
    reset,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: { ...contractsDefault, contracts: [...contracts] },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    contractCode: { required: "Please add contract code" },
    autoRenewFor: {
      validate: (value) => {
        if (getValues("autoRenew") && (!value || value === "0")) {
          return "Please add contract years";
        }
        return true;
      },
    },

    startDate: {
      validate: (value) => {
        if (moment().diff(moment(value), "days") < 0)
          return "Start date can not be previous date";
        return true;
      },
    },
    endDate: {
      validate: (value) => {
        if (moment(getValues("startDate")).diff(moment(value), "days") < 0)
          return "End date can not be before start date";
        return true;
      },
    },
  };

  const {
    fields: contractFields,
    remove: contractRemove,
    update: contractUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "contracts",
  });

  const { fields: contractSLAFields, remove: contractSLARemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "contractSLAs",
    });

  const { fields: invoicingCatalogFields, remove: invoicingCatalogRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "invoicingCatalogs",
    });
  useEffect(() => {
    if (addData) addData([...contractFields]);
  }, [watch("contracts")]);

  const submitInfo = (data) => {
    const _data = { ...data };
    const _contracts = [...contractFields];
    const contractObj = {
      contractCode: _data.contractCode,
      autoRenew: _data.autoRenew,
      autoRenewFor: _data.autoRenewFor,
      startDate: _data.startDate,
      endDate: _data.endDate,
      status: _data.status,
      contractSLAs: _data.contractSLAs,
      invoicingCatalogs: _data.invoicingCatalogs,
      expanded: false,
    };

    if (currentEditing !== null) {
      _contracts[currentEditing] = { ...contractObj };
      setCurrentEditing(null);
    } else {
      _contracts.push({ ...contractObj });
    }
    reset({ ...contractsDefault, contracts: _contracts });
  };

  const cancelEditing = () => {
    setCurrentEditing(null);
    const _contracts = [...contractFields];
    reset({ ...contractsDefault, contracts: _contracts });
  };
  const cancelSLAEditing = () => {
    setCurrentEditingSLA(null);
    reset({ ...getValues, ...contractSLADefault });
  };

  const cancelInvoicingCatalogEditing = () => {
    setCurrentEditingCatalog(null);
    reset({ ...getValues, ...invoicingCatalogDefault });
  };
  const addContractSLAs = () => {
    const _contractSLAs = [...contractSLAFields];
    const _data = { ...getValues() };
    clearErrors([
      "region",
      "serviceType",
      "activityType",
      "responseTime",
      "resolutionTime",
      "attendedTime",
    ]);
    let isDataValid = true;
    if (!_data.region) {
      setError("region", { type: "required", message: "Please select region" });
      isDataValid = true;
    }
    if (!_data.serviceType) {
      setError("serviceType", {
        type: "required",
        message: "Please select service type",
      });
      isDataValid = false;
    }
    if (!_data.activityType) {
      setError("activityType", {
        type: "required",
        message: "Please select activity type",
      });

      isDataValid = false;
    }
    if (!_data.responseTime || _data.responseTime === "0") {
      setError("responseTime", {
        type: "required",
        message: "Please add response time",
      });

      isDataValid = false;
    }
    if (!_data.attendedTime || _data.attendedTime === "0") {
      setError("attendedTime", {
        type: "required",
        message: "Please enter attended time",
      });

      isDataValid = false;
    }
    if (!_data.resolutionTime || _data.resolutionTime === "0") {
      setError("resolutionTime", {
        type: "required",
        message: "Please add resolution time",
      });

      isDataValid = false;
    }
    if (!isDataValid) return;

    const newItem = {
      region: _data.region,
      serviceType: _data.serviceType,
      activityType: _data.activityType,
      responseTime: _data.responseTime,
      attendedTime: _data.attendedTime,
      resolutionTime: _data.resolutionTime,
    };
    if (currentEditingSLA === null) {
      _contractSLAs.push(newItem);
    } else {
      _contractSLAs[currentEditingSLA] = newItem;
      setCurrentEditingSLA(null);
    }
    const _invoicingCatalogFields = [...invoicingCatalogFields];
    reset({
      ..._data,
      ...contractSLADefault,
      invoicingCatalogs: _invoicingCatalogFields,
      contractSLAs: _contractSLAs,
    });
  };

  const addInvoicingCatalog = () => {
    const _invoicingCatalogFields = [...invoicingCatalogFields];
    const _data = { ...getValues() };
    let isDataValid = true;
    clearErrors(["invoicingCode", "currency", "rate", "discount"]);
    if (!_data.invoicingCode) {
      setError("invoicingCode", {
        type: "required",
        message: "Please add invoicing code",
      });
      isDataValid = false;
    }
    if (!_data.currency) {
      setError("currency", {
        type: "required",
        message: "Please select currency",
      });
      isDataValid = false;
    }
    if (!_data.rate || _data.rate === "0") {
      setError("rate", {
        type: "required",
        message: "Please add rate",
      });
      isDataValid = false;
    }
    if (!_data.discount || _data.discount === "0") {
      setError("discount", {
        type: "required",
        message: "Please add discount",
      });
      isDataValid = false;
    }
    if (!isDataValid) return;
    const newItem = {
      invoicingCode: _data.invoicingCode,
      currency: _data.currency,
      rate: _data.rate,
      discount: _data.discount,
    };
    if (currentEditingCatalog === null) {
      _invoicingCatalogFields.push(newItem);
    } else {
      _invoicingCatalogFields[currentEditingCatalog] = newItem;
      setCurrentEditingCatalog(null);
    }
    const _contractSLAFields = [...contractSLAFields];
    reset({
      ..._data,
      ...invoicingCatalogDefault,
      invoicingCatalogs: _invoicingCatalogFields,
      contractSLAs: _contractSLAFields,
    });
  };

  const onStartDateChange = (e) => {
    setValue("endDate", e.value);
  };

  const expandChange = ({ dataIndex }) => {
    const _contracts = [...contractFields];
    _contracts[dataIndex].expanded = !_contracts[dataIndex].expanded;
    contractUpdate(dataIndex, _contracts[dataIndex]);
  };

  const editContractSLACell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit SLA"
          cursor="pointer"
          onClick={() => {
            reset({
              ...getValues(),
              ...dataItem,
              contracts: [...contractFields],
            });
            setCurrentEditingSLA(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteContractSLACell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Contract SLA "
          cursor="pointer"
          onClick={() => {
            contractSLARemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };

  const editCatalogCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Invoicing Catalog"
          cursor="pointer"
          onClick={() => {
            const _data = getValues();
            reset({ ..._data, ...dataItem });
            setCurrentEditingCatalog(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCatalogCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Invoicing Catalog "
          cursor="pointer"
          onClick={() => {
            invoicingCatalogRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };

  const editContractCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Invoicing Catalog"
          cursor="pointer"
          onClick={() => {
            reset({
              ...contractsDefault,
              ...dataItem,
              contracts: [...contractFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteContractCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Invoicing Catalog "
          cursor="pointer"
          onClick={() => {
            contractRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Contract SLAs
        </Heading>
        <Grid data={dataItem.contractSLAs}>
          <GridColumn field="region.text" title="Region" />
          <GridColumn field="serviceType.text" title="Service Type" />
          <GridColumn field="activityType.text" title="Activity Type" />
          <GridColumn field="responseTime" title="Response Time(mins)" />
          <GridColumn field="attendedTime" title="Attended Time(mins)" />
          .
          <GridColumn field="resolutionTime" title="Resolution Time(mins)" />
        </Grid>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",

            padding: "10px 0px",
            margin: 0,
          }}
        >
          Invoicing Catalog
        </Heading>
        <Grid data={dataItem.invoicingCatalogs}>
          <GridColumn field="invoicingCode" title="Code" />
          <GridColumn field="currency.name" title="Currency" />
          <GridColumn field="rate" title="Rate" />
          <GridColumn field="discount" title="Discount" />
        </Grid>
      </>
    );
  }

  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Contracts</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button type="button" onClick={() => onPrevStep(contractFields)}>
              Back
            </Button>
            <Button type="button" onClick={() => onNextStep(contractFields)}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <FormInput
        {...generalFieldProps}
        isRequired
        name="contractCode"
        label="Contract Code"
        rules={formValidationRules.contractCode}
      />
      <FormHookDatePicker
        {...generalFieldProps}
        label="Start Date"
        name="startDate"
        onDateChange={onStartDateChange}
        rules={formValidationRules.startDate}
        // datePickerProps={{ min: new Date() }}
      />
      <FormHookDatePicker
        {...generalFieldProps}
        label="End Date"
        name="endDate"
        rules={formValidationRules.endDate}
        // datePickerProps={{ min: watch("startDate") || new Date() }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        // isRequired={true}
        label="Status"
        name="status"
        id="id"
        text="text"
        data={contractStatus || []}
        placeholder="Select Status"
        disablePlaceholderItem
        // rules={formValidationRules.customerType}
        dropdownProps={{ filterable: false }}
      />
      <FormControl style={{ display: "flex", alignItems: "center" }}>
        <Controller
          control={generalFieldProps.control}
          name="autoRenew"
          render={({ field }) => {
            return (
              <Checkbox
                isChecked={field.value}
                onChange={() => {
                  const _value = !field.value;
                  field.onChange(_value);
                  setValue("autoRenewFor", "0");
                  if (errors.autoRenewFor) {
                    clearErrors("autoRenewFor");
                  }
                }}
              >
                <FormLabel style={{ margin: 0 }}> Auto Renew</FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <NumericInput
        {...generalFieldProps}
        label="Auto Renew For"
        name="autoRenewFor"
        isRequired={Boolean(watch("autoRenew"))}
        disabled={!watch("autoRenew")}
        info={watch("autoRenew") ? "" : "Set Auto Renew To Enable"}
        rules={formValidationRules.autoRenewFor}
        inputProps={{ min: 0 }}
      />
      <Heading
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      >
        Contract SLA
      </Heading>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        data={regionList}
        name="region"
        label="Region"
        id="id"
        text="text"
        placeholder="Select Region"
        // rules={formValidationRules.currency}
        dropdownProps={{ filterable: false }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        data={SERVICE_TYPES}
        name="serviceType"
        label="Service Type"
        id="id"
        text="text"
        placeholder="Select Service Type"
        // rules={formValidationRules.currency}
        dropdownProps={{ filterable: false }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        data={ACTIVITY_TYPES}
        name="activityType"
        label="Activity Type"
        id="id"
        text="text"
        placeholder="Select Activity Type"
        dropdownProps={{ filterable: false }}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="responseTime"
        label="Response Time(mins)"
        inputProps={{ format: "#", className: "hide-spinners" }}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="attendedTime"
        label="Attended Time(mins)"
        inputProps={{ format: "#", className: "hide-spinners" }}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="resolutionTime"
        label="Resolution Time(mins)"
        inputProps={{ format: "#", className: "hide-spinners" }}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditingSLA !== null ? (
          <Button type="button" onClick={cancelSLAEditing}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="button" onClick={addContractSLAs}>
          {currentEditingSLA !== null ? "Update SLA" : "Add SLA"}
        </Button>
      </div>
      <Grid data={contractSLAFields}>
        <GridColumn field="region.text" title="Region" />
        <GridColumn field="serviceType.text" title="Service Type" />
        <GridColumn field="activityType.text" title="Activity Type" />
        <GridColumn field="responseTime" title="Response Time(mins)" />
        <GridColumn field="attendedTime" title="Attended Time(mins)" />
        .
        <GridColumn field="resolutionTime" title="Resolution Time(mins)" />
        <GridColumn cell={editContractSLACell} title="Edit" />
        <GridColumn cell={deleteContractSLACell} title="Delete" />
      </Grid>
      <Heading
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      >
        Invoicing Catalog
      </Heading>
      <FormInput
        {...generalFieldProps}
        isRequired
        name="invoicingCode"
        label="Invoicing Code"
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        id="shortName"
        text="name"
        data={currencies || []}
        placeholder="Select Currency"
        // rules={formValidationRules.currency}
        dropdownProps={{ filterable: true }}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="rate"
        label="Rate"
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="discount"
        label="Discount"
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditingCatalog !== null ? (
          <Button type="button" onClick={cancelInvoicingCatalogEditing}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="button" onClick={addInvoicingCatalog}>
          {currentEditingCatalog !== null ? "Update Catalog" : "Add Catalog"}
        </Button>
      </div>
      <Grid data={invoicingCatalogFields}>
        <GridColumn field="invoicingCode" title="Code" />
        <GridColumn field="currency.name" title="Currency" />
        <GridColumn field="rate" title="rate" />
        <GridColumn field="discount" title="Discount" />
        <GridColumn cell={editCatalogCell} title="Edit" />
        <GridColumn cell={deleteCatalogCell} title="Delete" />
      </Grid>
      <div
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing}>Cancel</Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update Contract" : "Add Contract"}
        </Button>
      </div>
      <Grid
        data={contractFields}
        detail={DetailComponent}
        expandField="expanded"
        onExpandChange={expandChange}
      >
        <GridColumn field="contractCode" title="Contract Code" />
        <GridColumn field="autoRenewFor" title="Auto Renew For" />
        <GridColumn
          field="startDate"
          title="Start Date"
          cell={({ dataItem }) => (
            <td>
              {dataItem.startDate ? (
                moment(dataItem.startDate).format(dateFormat)
              ) : (
                <></>
              )}
            </td>
          )}
        />
        <GridColumn
          field="endDate"
          title="End Date"
          cell={({ dataItem }) => (
            <td>
              {dataItem.endDate ? (
                moment(dataItem.endDate).format(dateFormat)
              ) : (
                <></>
              )}
            </td>
          )}
        />
        <GridColumn field="status.text" title="Status" />
        <GridColumn
          title="Auto Renew"
          field="autoRenew"
          cell={({ dataItem }) => (
            <td>
              <Checkbox isChecked={dataItem.autoRenew} />
            </td>
          )}
        />

        <GridColumn cell={editContractCell} title="Edit Contract" />
        <GridColumn cell={deleteContractCell} title="Delete Contract" />
      </Grid>
    </form>
  );
}
